export default "__VITE_ASSET__gYlBpk9a__"